// extracted by mini-css-extract-plugin
module.exports = {"AlertBox":"AlertBox_AlertBox__2CCNa","message":"AlertBox_message__bkjyy","close":"AlertBox_close__5DdYC","presented":"AlertBox_presented__3A0MB"};